import Drawer from 'src/components/Drawer';
import { VaultSidebarInfoHeader } from 'src/components/Vaults/VaultSidebarInfoHeader';
import { VaultDetailsDrawerContent } from 'src/components/Vaults/VaultMainContent/VaultDetailsDrawerContent';
import { SubscribedVaultProvider } from 'src/providers/vaults/SubscribedVaultProvider';
import { useDrawersStore } from 'src/stores/useDrawersStore';
import Link from 'next/link';
import Button from '../../Button';
import { Typo } from '../../Text/Typo';
import { Open } from '@drift-labs/icons';
import useDriftStore from '../../../stores/DriftStore/useDriftStore';
import { useEffect } from 'react';

export const VaultDetailsDrawer = () => {
	const handleCloseVaultDetailsDrawer = useDrawersStore(
		(s) => s.handleCloseDrawer
	);
	const { vault } = useDrawersStore((s) => s.vaultDetails);

	const onClose = () => {
		handleCloseVaultDetailsDrawer('vaultDetails');
	};

	const appEventEmitter = useDriftStore((s) => s.appEventEmitter);

	// Sync the vault stats for the target vault
	useEffect(() => {
		appEventEmitter.emit('syncTargetVaultStats', [vault.vaultPubkeyString]);
	}, [appEventEmitter, vault.vaultPubkeyString]);

	return (
		<Drawer
			drawerName="vaultDetails"
			className="w-full sm:max-w-[400px] sm:w-[400px] thin-scroll overflow-y-auto flex flex-col"
		>
			<SubscribedVaultProvider vaultPubkey={vault.vaultPubkeyString}>
				<Drawer.Header
					titleContent={<VaultSidebarInfoHeader uiVaultConfig={vault} />}
					className="p-4"
					onClose={onClose}
				/>

				<Drawer.Body>
					<VaultDetailsDrawerContent uiVaultConfig={vault} onClose={onClose} />
				</Drawer.Body>

				<Drawer.Footer>
					<div className="flex flex-col gap-2">
						<div>
							<Link
								className="flex items-center justify-between w-full rounded cursor-pointer "
								href={`/vaults/strategy-vaults/${vault.vaultPubkeyString}`}
								onClick={(e) => {
									e.stopPropagation();
									onClose();
								}}
							>
								<Button.Secondary
									size="MEDIUM"
									className="flex items-center justify-center w-full gap-1"
								>
									<Typo.T2 className="group-hover:opacity-80">
										View Vault Details
									</Typo.T2>
								</Button.Secondary>
							</Link>
						</div>

						<div>
							<Link
								className="flex items-center justify-between w-full rounded cursor-pointer "
								href={`https://app.drift.trade?authority=${vault.vaultPubkeyString}`}
							>
								<Button.Secondary
									size="MEDIUM"
									className="flex items-center justify-center w-full gap-1"
								>
									<Typo.T2 className="group-hover:opacity-80">
										Inspect Vault Account
									</Typo.T2>
									<Open className="transition-transform -translate-x-2 group-hover:translate-x-0" />
								</Button.Secondary>
							</Link>
						</div>
					</div>
				</Drawer.Footer>
			</SubscribedVaultProvider>
		</Drawer>
	);
};
